import ApplicationController from "./application_controller.js"

export default class extends ApplicationController {

  static targets = [ "entityFormed", "gotFormID", "companyReviewState", "consultationLevel", "dpa",
                     "nonUsInvestors", "attorneyUpgradePrice", "filedformDs", "nextButton", "page",
                     "raiseMoreThan5M", "buyAttorneyUpgrade", "buyFormation"]

  initialize() {
    for (const b of this.element.querySelectorAll('button')) {
      b.disabled = true
    }
    this.showPage(0)
  }

  answer(ev) {
    const page = ev.target.closest('.page')
    this.enableNextButton(page)
  }

  enableNextButton(page) {
    page.querySelector('button').disabled = !this.isPageDone(page)
  }

  isPageDone(page) {
    const results = {}
    for (const input of (page.querySelectorAll('input,select'))) {
      if (input.nodeName == "SELECT" ? input.value != "" : input.checked) {
        results[input.name] = input.value
      }
    }
    return Object.keys(results).length == page.querySelectorAll('.question').length
  }

  get attorneyUpgradeTier() {
    if (this.selectedVal("raiseMoreThan5M") == "no") {
      return 1
    }

    const l = this.selectedVal("consultationLevel")
    return l == 'level-3' ? 3 :
           l == 'level-2' ? 2 :
                            1
  }

  get attorneyUpgradePrice() {
    let i = this.attorneyUpgradeTier - 1
    let price;
    if (this.variant == "Form C") {
      price = [1500, 2500, 3500][i]
     } else if (this.variant == "PPM") {
      price = [6500, 10000, 13500][i]
     } else {
      price = 2600
    }
    if (this.selectedVal("dpa") == "yes") {
      price += this.variant == "Form C" ? 2500 : 5000
    }
    return price
  }

  showPage(index) {
    this.attorneyUpgradePriceTarget.innerText = this.attorneyUpgradePrice
    let page = this.availablePages[index]
    if (page) {
      this.enableNextButton(page)
      this.index = index
      this.availablePages.forEach(el => {
        el.classList.toggle("page__current", el === page)
      })
      return true
    } else {
      return false
    }
  }

  next(ev) {
    if (this.showPage(this.index + 1)) {
      ev.preventDefault()
    }
  }

  get availablePages() {
    return this.pageTargets.filter(p => this.pageIsActive(p.getAttribute("data-page-name")))
  }

  get variant() { return this.data.get("variant"); }

  get nonUSInvestors() { return this.selectedVal("nonUsInvestors") == "yes" }

  pageIsActive(pageName) {
    switch (pageName) {
      case "consultation-1":
        return !this.nonUSInvestors;

      case "form-d":
        let c = this.selectedVal("consultationLevel")
        return c == "level-2" || c == "level-3"

      case "form-d-2":
        return this.selectedVal("filedformDs") == "no"

      case "formation":
        return this.selectedVal("entityFormed") == "no"

      case "formation-state":
        return this.selectedVal("buyFormation") == "yes"

      case "form-id":
        return this.selectedVal("gotFormID") == "no"

      case "company-review":
        return this.selectedVal("companyReviewState") == "review-necessary";

      case "attorney-upgrade":
        return !this.nonUSInvestors;

      case "full-service":
        return !this.nonUSInvestors && this.selectedVal("buyAttorneyUpgrade") == "yes";

      case "custom-review-contact":
        return this.nonUSInvestors;
    }
    return true
  }

  selectedVal(target) {
    var el = this[target + 'Targets'].find(el => el.checked)
    return el && el.value
  }

}
